function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_80",
  "data-name": "Groupe 80",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_79",
  "data-name": "Groupe 79"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_32",
  "data-name": "Trac\\xE9 32",
  d: "M31.763,102.37c-.286-.389-7.09-9.535-15.78-9.535S.488,101.981.2,102.37a1.049,1.049,0,0,0,0,1.24c.285.389,7.09,9.535,15.78,9.535S31.477,104,31.763,103.61A1.048,1.048,0,0,0,31.763,102.37Zm-15.78,8.674c-6.4,0-11.945-6.07-13.587-8.055C4.035,101,9.568,94.936,15.983,94.936s11.945,6.069,13.587,8.055C27.93,104.977,22.4,111.044,15.983,111.044Z",
  transform: "translate(0 -92.835)",
  fill: "#007cc0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_82",
  "data-name": "Groupe 82",
  transform: "translate(9.66 3.852)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_81",
  "data-name": "Groupe 81"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_33",
  "data-name": "Trac\\xE9 33",
  d: "M161.045,154.725a6.3,6.3,0,1,0,6.323,6.3A6.32,6.32,0,0,0,161.045,154.725Zm0,10.505a4.2,4.2,0,1,1,4.215-4.2A4.213,4.213,0,0,1,161.045,165.23Z",
  transform: "translate(-154.722 -154.725)",
  fill: "#007cc0"
})));

var SvgIcEye = function SvgIcEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "view",
    width: 31.966,
    height: 20.31,
    viewBox: "0 0 31.966 20.31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_eye.8dea0f42.svg";
export { ForwardRef as ReactComponent };